<template>
  <v-card>
    <v-card-title
      class="justify-center"
    >
      <h2>ADICIONAR FORMA DE PAGAMENTO</h2>
    </v-card-title>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formPag">
        <v-layout row wrap fill-height justify-space-between>
          <v-flex xs7>
            <v-text-field
              label="Descrição"
              :rules="[(v) => !!v || 'Esse campo é obrigatório']"
              v-model="dadosFormaPag.descricao"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-switch v-model="dadosFormaPag.em_producao" color="primary" label="Em produção"></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="URL de pagamento"
              v-model="dadosFormaPag.url"
              hide-details
              maxlength="200"
              required
              :rules="[
                v => !!v || ''
              ]"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Nomes dos campos separados por vingulas"
              v-model="dadosFormaPag.nome_campos"
              hide-details
              maxlength="200"
              required
              :rules="[
                v => !!v || ''
              ]"
            ></v-text-field>
          </v-flex>
          <!-- <v-combobox
            xs12
            v-model="dadosFormaPag.nome_campos"
            :items="items"
            label="Nome dos campos que serão usados pela forma de pagamento"
            chips
            clearable
            multiple
            no-resize
            required
            :rules="[
                v => !!v || 'Os campos são obrigatórios'
              ]"
          >
            <template v-slot:selection="data">
              <v-chip :selected="data.selected" close @input="remove(data.item)">
                <strong>{{ data.item }}</strong>&nbsp;
              </v-chip>
            </template>
          </v-combobox>-->
          <v-flex xs12>
            <v-text-field
              v-model="dadosFormaPag.endpoint_producao"
              label="Endpoint em produção"
              :rules="[(v) => !!v || 'Esse campo é obrigatório']"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="dadosFormaPag.endpoint_homologacao"
              label="Endpoint em homologação"
              :rules="[(v) => !!v || 'Esse campo é obrigatório']"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs6>
            <v-checkbox
              color="primary"
              label="Aceita crédito"
              hide-details
              v-model="dadosFormaPag.aceita_credito"
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              color="primary"
              label="Aceita débito"
              hide-details
              v-model="dadosFormaPag.aceita_debito"
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              color="primary"
              label="Aceita PIX"
              hide-details
              v-model="dadosFormaPag.aceita_pix"
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              color="primary"
              label="Aceita boleto"
              hide-details
              v-model="dadosFormaPag.aceita_boleto"
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              color="primary"
              label="Aceita cashback"
              hide-details
              v-model="dadosFormaPag.aceita_cashback"
            ></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              color="primary"
              label="Pagamento secundário"
              hide-details
              v-model="dadosFormaPag.pagamento_secundario"
            ></v-checkbox>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
      <v-btn
        flat
        color="info"
        @click="fechar()"
      >
        Voltar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        flat
        color="info" @click="inserirFormaPagamento()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formasPagDao } from '@/api'

export default {
  data () {
    return {
      valid: false,
      dadosFormaPag: {
        nome_campos: null,
        url: null,
        descricao: null,
        em_producao: false,
        endpoint_producao: null,
        endpoint_homologacao: null,
        aceita_credito: true,
        aceita_debito: true,
        aceita_pix: false,
        aceita_cashback: false,
        aceita_boleto: false,
        pagamento_secundario: false
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    }
  },
  methods: {
    remove (item) {
      this.dadosFormaPag.nome_campos.splice(
        this.dadosFormaPag.nome_campos.indexOf(item),
        1
      )
      this.dadosFormaPag.nome_campos = [...this.dadosFormaPag.nome_campos]
    },
    fechar () {
      this.$refs.formPag.reset()
      this.$emit('fechar')
    },
    inserirFormaPagamento () {
      if (this.$refs.formPag.validate()) {
        formasPagDao.insert(this.dadosFormaPag, this.headers).then(response => {
          if (response.ok) {
            this.$emit('complete', 'Forma de pagamento adicionada com sucesso')
          } else {
            this.$emit(
              'error',
              'Não foi possível adicionar a forma de pagamento'
            )
          }
        })
      }
    }
  }
}
</script>
